module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "praise"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/toc.htm#pra"
    }
  }, [_c('strong', [_vm._v("Praise for Val McDermid’s Lindsay Gordon series")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("“Her real skills in creating compelling characters, as well as a mystery that is profoundly twisted and filled with enough legitimate red herrings to stock Fisherman’s Wharf, blossom in this dark, chilling novel.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("—Bay Area Reporter")]), _vm._v(" on "), _c('em', [_vm._v("Final Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("“Val McDermid is an inspiration.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("—Herald")]), _vm._v(" (Scotland) on "), _c('em', [_vm._v("Common Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("“Tough, exciting, moody, and unpredictable.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("—Times")]), _vm._v(" (UK) on "), _c('em', [_vm._v("Union Jack")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("“McDermid’s snappy, often comic prose keeps the story humming.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("—Publishers Weekly")]), _vm._v(" on "), _c('em', [_vm._v("Common Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("“The macho world of the whodunnit has never seen a sleuth like Lindsay Gordon.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("—Manchester Evening News")]), _vm._v(" (UK) on "), _c('em', [_vm._v("Booked for Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("“Full marks for plot, atmosphere, character, dialogue, politics, humour—Oh hell, full marks for just about everything. I don’t know how Val does it, but I’m bloody glad she does.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("—Crime Time")]), _vm._v(" on "), _c('em', [_vm._v("Booked for Murder")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66053859","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/pra.vue
// module id = 57
// module chunks = 0